<template>
  <KeyboardTabMacro
    :max-macro-count="MOUSE_MACRO_MAX_COUNT"
    :max-macro-byte-length="MOUSE_MACRO_MAX_BYTE_LENGTH"
    :coordinate-min="macroCoordinateRange.min"
    :coordinate-max="macroCoordinateRange.max"
    :enabled-wheels="['vertical', 'horizontal']"
    disable-bind-toast
  />
</template>

<script setup lang="ts">
  import { computed, provide } from 'vue'
  import { storeToRefs } from 'pinia'
  import type { MouseKeysCapability } from '@rapoo/device-sdk'

  import { useDeviceStore } from '@/stores'
  import KeyboardTabMacro from '@/views/device/keyboard/keys/components/TabMacro/index.vue'
  import { MacroRepositorySymbol } from '@/views/device/keyboard/keys/components/TabMacro/types'
  import { useMouseMacroRepository } from '../composables/useMouseMacroRepository'

  // 鼠标宏数量最大 12；单条宏字节上限从 manifest `macro.maxLength` 读取
  const MOUSE_MACRO_MAX_COUNT = 12
  const MOUSE_MACRO_MAX_BYTE_LENGTH = 1024 * 4
  const DEFAULT_MACRO_COORDINATE_RANGE = { min: -2048, max: 2047 } as const

  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)
  const macroCoordinateRange = computed(() => {
    const capability = currentDevice.value?.manifest.capabilities.find(
      (item) => item.type === 'mouseKeys',
    ) as MouseKeysCapability | undefined
    return capability?.config.macroCoordinateRange ?? DEFAULT_MACRO_COORDINATE_RANGE
  })

  // 通过 inject 切换底层仓储为 mouseKeys feature 实现，UI 行为完全复用键盘版
  provide(MacroRepositorySymbol, useMouseMacroRepository)
</script>

<style scoped></style>
